export const lblEmptyShoppingText = 'lbl_orders_emptySupportingText';
export const lblEmptyOrdersText2 = 'lbl_orderHistory_empty_orders_text2';
export const lblEmptyOrdersText3 = 'lbl_orderHistory_empty_orders_text3';

export const EmptyOrdersListLabels = {
  account: {
    orders: {
      [lblEmptyShoppingText]: 'You have not placed any orders yet.',
      [lblEmptyOrdersText2]: 'modify your filter selection.',
      [lblEmptyOrdersText3]: 'Recent orders will display here. For orders older than 6 months, ',
    },
  },
};
